import React, { useEffect, useState } from 'react';
import { useParcelContext } from '../../../../components/ParcelProvider';
import Files from '@afosto/app-components-react/Files';
import formatFile from '@afosto/utils-react/files/formatFile';
import { files as filesApi } from '@afosto/content/api/Files';

const ParcelFiles = () => {
  const [files, setFiles] = useState([]);
  const { parcel } = useParcelContext();
  const { file_id: slipFileID, label } = parcel ?? {};
  const { file_id: labelFileID } = label ?? {};

  useEffect(() => {
    const fetchFiles = async ids => {
      try {
        const fileIds = ids.filter(id => id);
        const promises = fileIds.map(fileId => filesApi.getFile(fileId));
        const responses = await Promise.allSettled(promises).then(result =>
          result.filter(promise => promise.status === 'fulfilled'),
        );
        const formattedFiles = responses.reduce(
          (acc, response) => [...acc, { ...formatFile(response.value.data), isDeletable: false }],
          [],
        );

        setFiles(formattedFiles);
      } catch (err) {
        setFiles([]);
      }
    };

    if (slipFileID || labelFileID) {
      fetchFiles([slipFileID, labelFileID]).catch(() => {
        // Catch only
      });
    }
  }, [slipFileID, labelFileID]);

  return <Files files={files} allowUpload={false} />;
};

export default ParcelFiles;
